import { prateekBhaiya, mohitBhaiya, apaarBhaiya } from "../assets"

export const teamData = [
    {
        id: 1,
        image: prateekBhaiya,
        description1: 'Prateek is a popular programming instructor and an ace software engineer, currently working with Scaler and created Coding Minutes. He is known for his amazingly simplified explanations that make everyone fall in love with programming.',
        description2: 'He has over 5+ years of teaching experience and has trained over 75,000 students in classroom boot camps & online courses in the past.',
        linkedin: 'https://www.linkedin.com/in/prateeknarang27/',
        instagram: 'https://www.instagram.com/prateeknarang27/',
        youtube: 'https://www.youtube.com/@PrateekNarang27',

    },
    {
        id: 2,
        image: mohitBhaiya,
        description1: 'Mohit is a Data Scientist programming instructor and co-creator at Coding Minutes. He has trained over 10000+ students in Machine Learning, and AI over the last 2 years of his teaching experience. His expertise lies in Python, data science, machine learning and AI, and he has won many competitions.',
        description2: 'He has been doing AI-based projects for the last 4 years. He also leads the ML and Data Science Domain of Coding Minutes.',
        linkedin: 'https://www.linkedin.com/in/mohituniyal/',
        instagram: 'https://www.instagram.com/mohituniyal2010/',
        youtube: 'https://www.youtube.com/@CodingMinutes',
    },
    {
        id: 3,
        image: apaarBhaiya,
        description1: "Apaar is an ace Competitive Programmer and upcoming Google Software Engineer. He is rated 6 stars on Codechef & master on Codeforces, and has worked with companies like Zomato and Samsung. He loves to solve challenging problems and teach students.",
        description2: "He has been to ACM-ICPC and has won many hackathons. In the past 2 years, he has mentored thousands in Competitive Coding. Dynamic Programming & Graphs are his favorite topics.",
        linkedin: 'https://www.linkedin.com/in/apaarkamal/',
        instagram: 'https://www.instagram.com/apaargram/',
        youtube: 'https://www.youtube.com/@CodingMinutes/',
    }
]